export default {
  label: 'Portfolio balance',
};
